import styled from "styled-components";

export const Container = styled.div`
  padding: 16px 16px 0 16px;
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  border: 1px solid #d5d5d5;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 32px 20px;
  margin-bottom: 16px;

  cursor: pointer;
  width: 100%;
  :hover {
    background-color: #f5f5f5;
  }
`;
export const LightText: any = styled.p`
  display: flex;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #424248;
`;
